'use strict';

var _require = require('./ensure'),
    ensure = _require.ensure;

var _require2 = require('./ga-ecomm-helpers'),
    filterEcommEvents = _require2.filterEcommEvents,
    isEcommEvent = _require2.isEcommEvent;

module.exports = {
  ensure: ensure,
  filterEcommEvents: filterEcommEvents,
  isEcommEvent: isEcommEvent
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-beacon/utils/index.js
// module id = 859
// module chunks = 146